import { ModalVisualMode } from '@ui-components/containers/ModalTypes'
import { BodyText } from '@ui-components/typography/Typography'
import { FormattedMessage, IntlShape } from 'react-intl'

import { OpenModalEvent } from './modalMachine'

export const getOpenAbortModalEvent = (onAbort: () => void, intl: IntlShape): OpenModalEvent => {
  return {
    type: 'OPEN',
    data: {
      header: intl.formatMessage({ id: 'common-abort-modal-default-header' }),
      children: (
        <BodyText key="common-abort-modal-default-content" tagName="p">
          <FormattedMessage id="common-abort-modal-default-content" />
        </BodyText>
      ),
      primaryButtonOptions: {
        label: intl.formatMessage({ id: 'common-cancel' }),
      },
      secondaryButtonOptions: {
        label: intl.formatMessage({ id: 'common-abort-prompt-exit' }),
        onClick: onAbort,
      },
      mode: ModalVisualMode.Help,
    },
  }
}
